import withStep from '@/containers/withStep';

import { withFeatureToggledValidation } from '../withFeatureToggledValidation';
import DECompanyRegistrationId from './variants/DECompanyRegistrationId';
import ForcedCompanyRegistrationId from './variants/ForcedCompanyRegistrationId';
import OptionalCompanyRegistrationId from './variants/OptionalCompanyRegistrationId';
import OptionalRegistrationInformationDefault from './variants/OptionalRegistrationInformationDefault';
import TaxIdentificationNumber from './variants/TaxIdentificationNumber';
import { CONFIGURATION_KEY } from './constants';

export const VARIANTS = [
  DECompanyRegistrationId,
  ForcedCompanyRegistrationId,
  OptionalCompanyRegistrationId,
  TaxIdentificationNumber,
  OptionalRegistrationInformationDefault,
];

export default withFeatureToggledValidation('registrationId')(
  withStep('CompanyRegistrationId', {
    id: 'company-registration-id',
    description: 'Collects the registration number and authority when necessary',
    configurationKey: CONFIGURATION_KEY,
    variants: VARIANTS,
  }),
);
